import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FlatPickr from './FlatpickrWrapper'
import CalendarIcon from '@components/Icon/Calendar'
import { observer } from 'mobx-react'
import moment from 'moment'

class DatePicker extends Component {
  handleDateChange = ([selectedDate]) => {
    if (this.props.dateOnly && selectedDate) {
      this.props.onChange(moment(selectedDate).format('YYYY-MM-DD'))
    } else {
      this.props.onChange(selectedDate)
    }
  }

  render () {
    const {
      month,
      minDate,
      maxDate,
      date,
      error,
      disabled,
      backgroundColor,
      short
    } = this.props

    const selectedDate = date ? moment(date).toDate() : null
    const options = {
      dateFormat: month ? 'M Y' : 'd M Y',
      defaultDate: selectedDate,
      allowInput: false,
      altInput: false,
      minDate: minDate ? moment(minDate).toISOString() : null,
      maxDate: maxDate ? moment(maxDate).toISOString() : null
    }

    const wrapperClasses = classNames({
      datepicker__wrapper: true,
      'datepicker__wrapper--month': month,
      'datepicker__wrapper--error': error,
      'datepicker__wrapper--disabled': disabled,
      'datepicker__wrapper--short': short
    })

    const datepickerClasses = classNames({
      datepicker: !backgroundColor,
      'datepicker-color': backgroundColor,
      'datepicker--disabled': disabled
    })

    return (
      <div className={wrapperClasses}>
        <FlatPickr
          value={selectedDate}
          disabled={disabled}
          className={datepickerClasses}
          onChange={this.handleDateChange}
          options={options}
          ref={dp => {
            this.datepicker = dp
          }}
        />
        <CalendarIcon inside right noClick gray />
      </div>
    )
  }
}

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  short: PropTypes.bool,
  month: PropTypes.bool,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  backgroundColor: PropTypes.bool,
  dateOnly: PropTypes.bool
}

export default observer(DatePicker)
